import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import StickyBox from "react-sticky-box";
import { GetGiftCardOrders, GetGiftCardSerials } from '../../services/api';
import Swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import moment from 'jalali-moment';
import Modal from 'react-responsive-modal';

class Orders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            serials: []
        }
    };


    state = {
        loading: false,
        orders: null,
    }
    async componentDidMount() {
        this.setState(state => ({ ...state, loading: true }));
        this.getOrders();
        this.setState(state => ({ ...state, loading: false }));
    };
    onOpenModal = async (id) => {
        this.setState({ open: true });
        let data = await GetGiftCardSerials(id)
        this.setState({ serials: data.data.response.data.serials })
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    getOrders = async () => {
        if (localStorage.getItem("user_info")) {
            let userInfo = JSON.parse(localStorage.getItem("user_info"));
            let data = {
                customerId: userInfo.customerID,
                take: 0,
                skip: 0,
            };
            let orders = (await GetGiftCardOrders(data)).data.response.data;
            this.setState(state => ({ ...state, orders }));
        }
        else {
            return this.props.history.push('/pages/login');
        }
    };

    convertDate = (date) => {
        if (date) {
            return moment(date).locale('fa').format("YYYY/MM/DD HH:mm")
        }
    };

    numSeparator = (num) => {
        if (num) {
            return (num / 10).toLocaleString();
        }
    };


    converOrderStatus = (status) => {
        let result = '';
        switch (status) {
            case 1:
                result = 'ثبت شده';
                break;

            case 2:
                result = 'در حال انجام';
                break;

            case 3:
                result = 'تکمیل شده';
                break;

            case 4:
                result = 'لغو شده';
                break;

            default:
                result = status;
                break;
        }
        return result;
    };

    render() {
        return (
            <div>
                <table className='table'>
                    <thead>
                        <th>شناسه سفارش</th>
                        <th>تاریخ</th>
                        <th>نام محصول</th>
                        <th>سریال</th>
                        <th>وضعیت پرداخت</th>
                        <th>مبلغ (تومان)</th>
                        <th>تعداد</th>
                    </thead>
                    <tbody>
                        {this.state.orders && this.state.orders.map(order =>
                            <tr>
                                <td>{order.paymentId}</td>
                                <td dir='ltr'>{this.convertDate(order.createDate)}</td>
                                <td>{order.productName || '---'}</td>
                                <td ><button disabled={order.orderStatus === 1 || order.orderStatus === 4} onClick={(e) => this.onOpenModal(order.id)} className='btn'>سریال</button></td>
                                {order.orderStatus === 1 && <td><span className='p-1' style={{ background: '#0303ce', borderRadius: '6px', color: '#ffffff', fontSize: '15px',whiteSpace: 'nowrap' }}>{this.converOrderStatus(order.orderStatus)}</span></td>}
                                {order.orderStatus === 2 && <td><span className='p-1' style={{ background: '#ff7c0a', borderRadius: '6px', color: '#ffffff', fontSize: '15px',whiteSpace: 'nowrap' }}>{this.converOrderStatus(order.orderStatus)}</span></td>}
                                {order.orderStatus === 3 && <td><span className='p-1' style={{ background: '#008d00', borderRadius: '6px', color: '#ffffff', fontSize: '15px' ,whiteSpace: 'nowrap'}}>{this.converOrderStatus(order.orderStatus)}</span></td>}
                                {order.orderStatus === 4 && <td><span className='p-1' style={{ background: '#b90202', borderRadius: '6px', color: '#ffffff', fontSize: '15px',whiteSpace: 'nowrap' }}>{this.converOrderStatus(order.orderStatus)}</span></td>}
                                <td>{this.numSeparator(order.price)}</td>
                                <td>{order.productCount}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                
                <Modal open={this.state.open} onClose={this.onCloseModal} center className="cart-modal">
                     
                                <table className='table mt-5'>
                                    <thead>
                                        <th>ردیف</th>
                                        <th>سریال</th>

                                    </thead>
                                    {this.state.serials && this.state.serials.map((serial,i) =>
                                        <tr>
                                            <td>{i+1}</td>
                                            <td>{serial.serial}</td>
                                        </tr>
                                    )}
                                    {!this.state.serials && 
                                    <div>
                                        <h5>در حال حاضر دیتایی برای نمایش وجود ندارد!</h5>
                                        <h6 style={{color: 'green'}}>لطفا کمی صبر کنید.</h6>
                                    </div>
                                    }
                                </table>
                        
                </Modal>
            </div>
        )
    }
}

export default withRouter(Orders);